<template>
  <div class="profession-speciality-field form-group">
    <label class="control-label col-sm-2" :for="fieldId">
      {{ name }}
      <span class="text-danger" v-if="required">*</span>
    </label>
    <div class="col-sm-9">
      <!-- Profession -->
      <ValidationProvider
        class="profession-field"
        :rules="rules"
        :name="fieldId"
        tag="div"
        v-slot="{ errors }"
      >
        <select
          :id="fieldId + '_profession'"
          :name="fieldId + '_profession'"
          v-model="computedProfessionId"
          :title="tooltip"
          class="form-control"
          :required="required"
          :disabled="!enabled"
        >
          <option :value="null"></option>
          <option
            v-for="option in professionOptions"
            :key="option.value"
            :value="option.value"
            >{{ option.label }}</option
          >
        </select>
        <div>
          <small
            v-for="error in errors"
            :key="error"
            class="text-danger input-error"
            >{{ error }}</small
          >
        </div>
      </ValidationProvider>
      <!-- Speciality -->
      <div v-if="hasSpecialityOptions">
        <select
          :id="fieldId + '_specialities'"
          :name="fieldId + '_specialities'"
          v-model="computedSpecialityId"
          :title="tooltip"
          class="form-control"
          :disabled="!enabled"
        >
          <option :value="null"></option>
          <option
            v-for="option in specialityOptions"
            :key="option.value"
            :value="option.value"
            >{{ option.label }}</option
          >
        </select>
        <div>
          <small
            v-for="error in errors"
            :key="error"
            class="text-danger input-error"
            >{{ error }}</small
          >
        </div>
      </div>
      <small class="text-muted input-description">{{ description }}</small>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { ValidationProvider } from "vee-validate";

import { SharedService } from "../../../Commons/services/SharedService";

export default Vue.extend({
  name: "profession-speciality",
  components: {
    ValidationProvider,
  },
  data() {
    return {
      specialities: [],
      professions: [],
    };
  },
  props: {
    fieldId: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    tooltip: String,
    description: String,
    required: {
      type: Boolean,
      default: false,
    },
    enabled: {
      type: Boolean,
      default: true,
    },
    professionId: Number,
    specialityId: Number,
  },
  computed: {
    rules() {
      const rules = {};
      if (this.required) {
        rules["required"] = true;
      }
      return rules;
    },
    computedSpecialityId: {
      get: function() {
        return this.specialityId;
      },
      set: function(newVal) {
        this.$emit("update:specialityId", newVal);
      },
    },
    computedProfessionId: {
      get: function() {
        return this.professionId;
      },
      set: function(newVal) {
        this.$emit("update:professionId", newVal);
      },
    },
    filteredSpecialities() {
      return this.specialities.filter(
        (spe) => spe.idProfession === this.computedProfessionId
      );
    },
    professionOptions() {
      return this.professions.map((pro) => ({
        value: pro.id,
        label: pro.name,
      }));
    },
    specialityOptions() {
      return this.filteredSpecialities.map((spe) => ({
        value: spe.id,
        label: spe.name,
      }));
    },
    hasSpecialityOptions() {
      return (
        this.filteredSpecialities.map((spe) => ({
          value: spe.id,
          label: spe.name,
        })).length > 0
      );
    },
  },
  methods: {
    async getSpecialities() {
      this.specialities = await SharedService.getSpecialities();
    },
    async getProfessions() {
      this.professions = await SharedService.getProfessions();
    },
  },
  created() {
    this.getSpecialities();
    this.getProfessions();
  },
  watch: {
    computedProfessionId: {
      handler() {
        this.computedSpecialityId = null;
      },
    },
  },
});
</script>

<style scoped>
.profession-field + .speciality-field {
  margin-top: 10px;
}
</style>
